import Icon from 'components/icon';
import type React from 'react';
import { forwardRef } from 'react';
import './SignatureBaseButton.less';
import type { SignatureColor } from './utils';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  color: SignatureColor;
}

export const SignatureBaseButton = forwardRef<HTMLButtonElement, Props>(
  ({ color, className = '', draggable = false, children, ...props }, ref) => {
    return (
      <button ref={ref} className={`signature_button user_color ${color} ${className}`} draggable={draggable} {...props}>
        <Icon className="signature_button__icon" name="IcoSignaturePen" />
        <span className="signature_button__content">{children}</span>
      </button>
    );
  }
);

SignatureBaseButton.displayName = 'SignatureBaseButton';
